import { authComponents_svSE } from "@ssf/auth-components";
import { components_svSE, markdownToHtmlSync } from "@ssf/components";
import { memdbComponents_svSE } from "@ssf/memdb-components";
import { playComponents_svSE } from "@ssf/play-components";
import i18next from "i18next";
import { merge } from "lodash";
import { initReactI18next } from "react-i18next";

import y2cWeb_svSE from "../locales/locale.sv-SE.json";

const svSE = {
  ...merge(
    components_svSE,
    authComponents_svSE,
    playComponents_svSE,
    memdbComponents_svSE,
    y2cWeb_svSE,
  ),
  Questions: [...memdbComponents_svSE.Questions, ...y2cWeb_svSE.Questions],
};

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "common";
    resources: typeof y2cWeb_svSE;
  }
}

i18next
  .use(initReactI18next)
  .use({
    type: "postProcessor",
    name: "markdown",
    process(value: string) {
      return markdownToHtmlSync(value);
    },
  })
  .init({
    lng: "svSE",
    fallbackLng: "svSE",
    defaultNS: "common",
    resources: { svSE },
    react: {
      useSuspense: true,
      transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p",
        "em",
        "a",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "ul",
        "ol",
        "li",
      ],
    },
  });

i18next.services.formatter?.add("lowercase", (value) => value.toLowerCase());

export { i18next };
